($ => {
	$('.input-password__toggle').click(({currentTarget}) => {
		const context = $(currentTarget).parent();
		const input = $('.input-password__input', context);
		const type = input.attr('type');
		const target = type === 'password' ? 'text' : 'password';
		input.attr('type', target);
		context.removeClass('input-password_password input-password_text');
		context.addClass(`input-password_${target}`);
	});
})(jQuery);
